import userPrepaidCardQueries from '@apis/queries/userPrepaidCardQueries';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

interface Props {
    cardId: string;
}

function ChargeCardSummary({ cardId }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { data } = useQuery(userPrepaidCardQueries.detail(cardId));

    return (
        <Wrapper>
            <Row spacing={4} align='center' fullWidth>
                <CardImage src={data?.imageUrl}
                    width={90}
                    height={60}
                    alt={t('components.info.cardAlt')} />
                <Column spacing={1}>
                    <Text size='title' fontWeight='bold' multiline>
                        {data?.name}
                    </Text>
                    <Text size='body-short' fontWeight='regular' multiline>
                        {t('charge.balanceLabel', {
                            amount: (data?.balance ?? 0).toLocaleString(),
                        })}
                    </Text>
                </Column>
            </Row>
        </Wrapper>
    );
}

const Wrapper = styled.section`
    background-color: var(--color-white);
    padding: var(--spacing-4);
    width: 100%;
`;

const CardImage = styled(Image)`
    border-radius: 8px;
    flex-shrink: 0;
    object-fit: cover;
`;

export default ChargeCardSummary;
